import api from '../services/authService';
// sample API structure
export const editPDF = async (docID) => {
    const response = await api.post(`/documents/lock/${docID}/${localStorage.getItem("user_id")}/`, {});
    return response;
};

export const editPDFUnLock = async (docID) => {
  const response = await api.post(`/documents/unlock/${docID}/${localStorage.getItem("user_id")}/`, {});
  return response;
};

export const pdfRenameDocument = async (docID, newPDFName) => {
  const response = await api.post(`/documents/${docID}/rename/`, {name: newPDFName});
  return response;
}
